export default __webpack_public_path__ + "static/media/step5_img2.a309f37e.png";